<ui-page-header subtitle="Alle wichtigen Unterlagen für Ihren Shop an einem Ort.">
  Dokumente
</ui-page-header>

@if (documentsResource.isLoading()) {
  <ui-document-overview-skeleton></ui-document-overview-skeleton>
} @else if (documentsResource.error()) {
  <div class="section-wrapper">
    <ui-alert class="full-width" theme="error" message="Beim Laden der Dokumente ist ein Fehler aufgetreten. Bitte versuchen Sie es später noch einmal."></ui-alert>
  </div>
} @else if (groups().length === 0) {
  <div class="section-wrapper">
    <div class="no-results-container">
      <ui-icon faName="empty-set" faStyle="light"></ui-icon>
      <h2>Keine Dokumente</h2>
      <p>Zur Zeit sind keine Dokumente für Sie verfügbar.</p>
    </div>
  </div>
} @else {
  <ui-form-chip-filter-group
    [(selected)]="selectedFilterChips"
    [filterChips]="filterChips()"
    [totalCount]="documents().length"
    allLabel="Alle Dokumente"
  ></ui-form-chip-filter-group>

  @for (group of visibleGroups(); track group.tag.slug) {
    <section class="group">
      <div class="group-header">
        <span [style.background-color]="group.tag.iconBackgroundColor" class="group-icon">
          <ui-icon [faName]="group.tag.icon ?? 'folder'" faStyle="light"></ui-icon>
        </span>
        <div class="group-heading">
          <h2 class="group-title">{{ group.tag.label }}</h2>
          @if (group.tag.description) {
            <p class="group-description">{{ group.tag.description }}</p>
          }
        </div>
      </div>

      <div class="documents-panel">
        <mat-list class="documents-list">
          @for (tile of group.tiles; track tile.document.id) {
            <mat-list-item>
              <ui-icon [faName]="tile.document.type === 'link' ? 'link' : 'file-pdf'" faStyle="light" matListItemIcon></ui-icon>
              <span matListItemTitle>{{ tile.document.name }}</span>
              <span matListItemLine>{{ tile.meta }}</span>
              @if (tile.document.type === 'link') {
                <ui-icon-button
                  (clicked)="onOpen(tile.document)"
                  buttonStyle="unthemed"
                  icon="arrow-up-right-from-square"
                  iconStyle="light"
                  matListItemMeta
                  tooltip="Öffnen"
                  tooltipPosition="above"
                ></ui-icon-button>
              } @else {
                <ui-icon-button
                  (clicked)="onDownload(tile.document)"
                  [loading]="downloadingFileIdentifiers().has(tile.document.fileIdentifier ?? '')"
                  buttonStyle="unthemed"
                  icon="download"
                  iconStyle="light"
                  matListItemMeta
                  tooltip="Herunterladen"
                  tooltipPosition="above"
                ></ui-icon-button>
              }
            </mat-list-item>
          }
        </mat-list>
      </div>
    </section>
  }
}
